<script>
import QRCode from 'qrcode'
export default {
  name: 'QRcode',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      qrImageData: ''
    }
  },
  created() {
    this.setQrcode()
  },
  methods: {
    async setQrcode() {
      const { url } = this
      const dataURL = await QRCode.toDataURL(url, { margin: 7 })
      this.qrImageData = dataURL
    }
  }
}
</script>
<template>
  <div class="qrcode-wrap">
    <div class="qrcode">
      <img :src="qrImageData" alt="二维码">
    </div>
    <p>长按二维码识别详情</p>
  </div>
</template>
<style lang="postcss" scoped>
@import 'variable.css';
.qrcode-wrap {
  text-align: center;
  .qrcode {
    width: 1.7rem;
    margin: 0.3rem auto 0.24rem;
    > img {
      width: 100%;
      vertical-align: middle;
    }
  }
  > p {
    font-size: 0.24rem;
    font-weight: bold;
    color: #333;
  }
}
</style>
